import { DataTable } from "@marketplace/ui/data-table";

import type { RecurringOrderListItem } from "../../dtos/get-recurring-order-list-response-dto";
import { useRecurringOrderListTableColumns } from "../../hooks/use-recurring-order-list-table-columns";

type RecurringOrdersTableProps = {
  records: RecurringOrderListItem[];
};

export const RecurringOrdersTable: React.FC<RecurringOrdersTableProps> = ({
  records
}) => {
  const { columns } = useRecurringOrderListTableColumns();

  return <DataTable minHeight={10} columns={columns} records={records} />;
};
